import React from 'react'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
      {/*
        <div className="logo">
            <span className="icon fa-warning"></span>
        </div>
      */}
        <div className="content">
            <div className="inner">
                <h1>PLEASE STOP</h1>
                <p>Brisbane's Best Value Band</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('gigs')}}>Gigs</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('merch')}}>Merch</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>About</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('connect')}}>Connect</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: React.PropTypes.func,
    timeout: React.PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js